// extracted by mini-css-extract-plugin
export default {"input_header":"AddCategory_input_header__1tKm7","input":"AddCategory_input__Upcjs","save_btn":"AddCategory_save_btn__fO4rp","text_danger":"AddCategory_text_danger__nCCSb"};